import * as React from "react";
import { RES_URL } from "../../config";
import { Translation, ImagesData } from "../../models/models";
import { Footer } from "../../components/ui/Footer/Footer";
import { NavBar } from "../../components/ui/NavBar/NavBar";
import { Spinner } from "../../components/ui/Spinner/Spinner";
import { ImageContent } from "../../components/ui/ImageContent/ImageContent";
import { Dictionary } from "strikejs-react";
import { SelectionBar } from "../../components/ui/SelectionBar/SelectionBar";
import { SCREEN_WIDTH } from "../../constants";
import { SHOW_FULLSCREEN_IMAGE } from "../../components/ui/Dialog/Utils";

export interface MainPageProps {
  className?: string;
  locale: Translation;
  route: string;
  data: any;
  tritanopia?: any;
  protanopia?: any;
  deuteranopia?: any;
  keyData?: Dictionary<ImagesData>;
}

export interface MainPageState {
  currentIdx: number;
  currentImage: any;
  isSelectionVisible: boolean;
  fullScrrenActive: boolean;
}

declare var jQuery, dataLayer;

export class MainPage extends React.Component<MainPageProps, MainPageState> {
  el: HTMLDivElement;
  imageInfoEl: ImageContent;
  constructor(props: MainPageProps) {
    super(props);
    this.state = {
      currentIdx: 0,
      currentImage: null,
      isSelectionVisible: false,
      fullScrrenActive: false
    };
  }

  componentDidMount() {
    this.el = document.querySelector("#SiteContainer");
    if (this.props.data.length > 0 && this.state.currentImage === null) {
      let currentImage = this.props.keyData[this.props.route];
      this.setState({
        currentImage,
        currentIdx: this.props.data.indexOf(currentImage)
      });
    }
    {
      document.addEventListener("keydown", this.keyPressed);
    }

    window.addEventListener("resize", this.resize);
  }

  componentDidUpdate(prevProps: MainPageProps, prevState: MainPageState) {
    if (
      (!this.state.currentImage &&
        this.props.data.length !== prevProps.data.length) ||
      prevProps.route !== this.props.route
    ) {
      let currentImage = this.props.keyData[this.props.route];
      this.setState({
        currentImage,
        currentIdx: this.props.data.indexOf(currentImage)
      });
    }
  }

  componentWillUnmount() {
    this.el = document.querySelector("#SiteContainer");
    {
      document.removeEventListener("keydown", this.keyPressed);
    }
    window.removeEventListener("resize", this.resize);
  }

  resize = () => this.forceUpdate();

  handleOpenNext = () => {
    let nextImageId;
    let newIdx = this.state.currentIdx + 1;
    dataLayer.push({
      event: "clickEvent",
      clickEvent: "next-"+ newIdx
    });
    this.setState({
      currentIdx: newIdx
    });

    setTimeout(e => {
      const nextImageId = this.props.data[newIdx].id;
      const nextParentId = this.props.data[newIdx].parent;
      window.location.href = `#/${nextParentId}/${nextImageId}`;
    }, 10);
  };

  handleOpenPrev = () => {
    let newIdx = this.state.currentIdx - 1;
    dataLayer.push({
      event: "clickEvent",
      clickEvent: "prev-"+newIdx
    });
    this.setState({
      currentIdx: newIdx
    });

    setTimeout(e => {
      const nextImageId = this.props.data[newIdx].id;
      const nextParentId = this.props.data[newIdx].parent;
      window.location.href = `#/${nextParentId}/${nextImageId}`;
    }, 100);
  };

  keyPressed = e => {
    e = e || window.event;
    if (e.keyCode == "37") {
      e.preventDefault();
      if (this.state.currentIdx !== 0) {
        this.handleOpenPrev();
      }
    } else if (e.keyCode == "39") {
      e.preventDefault();
      if (this.state.currentIdx < this.props.data.length - 1) {
        this.handleOpenNext();
      }
    } else if (e.keyCode == "13") {
    }
  };

  handleAlbumClick = () => {
    this.setState({
      isSelectionVisible: true
    });
  };

  closeSelection = () => {
    this.setState({
      isSelectionVisible: false
    });
  };


  render() {
    let cls = this.props.className || "";
    let item = this.props.data[this.state.currentIdx];
   

    if (!item) {
      return (
        <div className="center">
          <Spinner />
        </div>
      );
    }
    return (
      <div className={"main-page " + cls}>

        <div className="main-page__content row center">
          <div className="col s12 m12 l3 xl3 main-page__navbar">
            <NavBar locale={this.props.locale} route={this.props.route} />
          </div>

          <div className="col s12 m12 l9 xl9 main-page__image-section">
            <ImageContent
              locale={this.props.locale}
              item={this.props.data[this.state.currentIdx]}
              key={this.props.data[this.state.currentIdx].id}
              currentIndex={this.state.currentIdx}
              onNextClick={this.handleOpenNext}
              onPrevClick={this.handleOpenPrev}
              isFirstPage={this.state.currentIdx === 0}
              isLastPage={this.state.currentIdx === this.props.data.length - 1}

             
            />
          </div>
          <div className="col s12 m12 l12 main-page__selection-bar">
            
            <SelectionBar
              data={this.props.data}
              selectedIndex={this.state.currentIdx}
              className={this.state.isSelectionVisible && "sidebar-visible"}
              closeSelection={this.closeSelection}
              keyItem={this.props.data[this.state.currentIdx].id}
              route={this.props.route}
              isSelectionVisible={this.state.isSelectionVisible}
            />
          </div>
          <Footer
            locale={this.props.locale}
            footerVisible={this.state.isSelectionVisible}
          />
        </div>
        {/* )} */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/MainPage/MainPage.tsx